
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { faceTempleteService } from "@/api/payments/faceTempleteService";
import { FaceTempleteDto } from "@/api/service-proxies";

@Component({})
export default class FaceTempleteClass extends Vue {
    @Prop()faceTemplete!: FaceTempleteDto 

  created() {
    
  }



}
